export default __webpack_public_path__ + "static/media/team-4.99c612eb.jpg";